'use client';
import React from 'react';
import { motion } from 'framer-motion';

const SustainabilityHero = () => {
  return (
    <section className="w-full relative min-h-[500px] sm:min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-[#050a10]">
      {/* Eco-Conscious Premium Background */}
      <motion.div
        initial={{ scale: 1.1, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 1.5, ease: "easeOut" }}
        className="absolute inset-0 bg-cover bg-center bg-no-repeat z-0"
        style={{ backgroundImage: "url('/images/premium_eco_packaging_hero.png')" }}
      >
        <div className="absolute inset-0 bg-black/30 backdrop-blur-[2px]"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#050a10] via-transparent to-transparent"></div>
      </motion.div>

      <div className="w-full max-w-[1440px] mx-auto px-6 sm:px-10 lg:px-16 relative z-10 py-24 sm:py-32">
        <div className="flex flex-col items-center text-center max-w-[900px] mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="flex flex-col gap-8 items-center"
          >
            <span className="inline-flex items-center px-5 py-2 rounded-full bg-white/[0.05] border border-white/10 text-white/90 text-[11px] font-bold tracking-[0.4em] uppercase">
              Ethics + Excellence
            </span>

            <h1 className="text-white text-5xl sm:text-7xl lg:text-[84px] leading-[0.9] font-bold tracking-tight">
              Future-Forward <br />
              <span className="font-serif italic text-white/80">Sustainability.</span>
            </h1>

            <p className="text-white/60 max-w-[650px] text-lg sm:text-xl md:text-2xl leading-relaxed font-light">
              Pioneering the next generation of <span className="text-white font-medium">eco-conscious labeling</span> solutions without compromising on technical precision or premium aesthetic.
            </p>
          </motion.div>
        </div>
      </div>

      {/* Refined bottom curve matching the previous design's intent but more premium */}
      <div className="absolute bottom-0 left-0 w-full h-24 bg-gradient-to-t from-white to-transparent opacity-10"></div>
    </section>
  );
};

export default SustainabilityHero;